import type { LinkProps } from '@tanstack/react-router'

import type { ProjectStatus } from '@brickup/shared/enums'
import { PROJECT_STATUS_LABELS } from '@brickup/shared/locales/de/enum-labels'
import { Badge } from '@/components/base'
import { PROJECT_STATUS_STYLE } from '@/constants/project-status-options'

/** A project's state, in the colour the whole app gives it. */
export function ProjectStatusBadge({
  status,
  count,
  link,
}: {
  status: ProjectStatus
  /** How many projects are in this state, where the pill is a tally rather
   *  than one project's state. */
  count?: number
  /** The list narrowed to this state. */
  link?: LinkProps
}) {
  return (
    <Badge
      size="sm"
      variant={PROJECT_STATUS_STYLE[status].tone}
      icon={PROJECT_STATUS_STYLE[status].icon}
      label={
        count === undefined
          ? PROJECT_STATUS_LABELS[status]
          : `${PROJECT_STATUS_LABELS[status]} ${count}`
      }
      link={link}
    />
  )
}
